// export const VALIDATE_POLICY_QUERY = (policy_id: string) => (`mutation {
//   validatePolicy(
//     applicationId: "as"
//     input: {
//       policy_id: "${policy_id}"
//     }
//   ){
//     valid
//     error_message
//     errors {
//       type
//       message
//     }
//   }
// }
// `)
// export const VALIDATE_POLICY_QUERY = (policy_id: string) => (`mutation {
//   validateCoviePolicy(policyId: "${policy_id}")
// 	{
//     ... on ValidationOutput {
//       valid
//     },
//     ... on ErrorListOutput {
//       errors {
//         message,
//         type
//       }
//     }
//   }
// }
// `)
import moment from 'moment';

type Address = {
  street: string;
  addressNumber: string;
  postalCode: string;
  municipality: string;
  region: string;
};

export const VALIDATE_POLICY_QUERY = (
  policy_id: string,
  name: string,
  firstName: string,
  lastName: string,
  email: string,
  address: Address,
  buildingUnit: string,
  leaseStart: string,
  leaseEnd: string,
  buildingId?: string,
) => {
  const buildingIdCheck = buildingId ? `buildingId: "${buildingId}",`: '';
return `mutation {
  validateCoviePolicy(
    input: {
      policyId: "${policy_id}",
      name: "${name}",
      firstName: "${firstName}",
      lastName: "${lastName}",
      email: "${email}",
      buildingUnit: "${buildingUnit}",
      ${buildingIdCheck}
      address :{
        street: "${address.street}",
        addressNumber: "${address.addressNumber}",
        postalCode: "${address.postalCode}",
        municipality: "${address.municipality}",
        region: ${address.region}
      }
      leaseStart:"${moment(leaseStart).format('YYYY-MM-DD')}",
      leaseEnd:"${moment(leaseEnd).format('YYYY-MM-DD')}"
    }
  ) {
    ...on ApplicationWithValidationOutput {
      validation {
        errors {
          id
          message
          type
        }
      }
      application {
        id
        status
      }
    }
    ...on ErrorListOutput {
      errors{
        type
        message
      }
    }
  }
}
`};
